module.exports = __webpack_public_path__ + "static/media/spid-idp-lepidaid~YGVaJzCf.34e0a1b5.svg";